import React from "react";
import Flx from "../layout/Flx";
import { Button } from "@mui/material";

const RedesignBanner = ({ active, onClick, show }) => {
  if (!show) return null;
  return (
    <Flx
      fw
      sx={{
        background: "#ffef6688",
        p: 2,
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
      }}
      center
    >
      <Button onClick={(s) => onClick((s) => !active)}>
        {active
          ? " Switch to Live (Dev Only)"
          : " Switch to Redesign (Dev Only)"}
      </Button>
    </Flx>
  );
};

export default RedesignBanner;
